
export default function WhatWeOffer() {
  const offerings = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'Educación infantil integral 0-3 años',
      description: 'Programa completo adaptado a cada etapa del desarrollo'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Plan educativo personalizado',
      description: 'Seguimiento individual del progreso de cada niño'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Actividades lúdicas y sensoriales',
      description: 'Experiencias que estimulan todos los sentidos'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Desarrollo del lenguaje',
      description: 'Estimulación temprana de la comunicación verbal'
    },
    {
      icon: 'ri-palette-line',
      title: 'Artes plásticas y creatividad',
      description: 'Expresión artística y desarrollo de la imaginación'
    },
    {
      icon: 'ri-puzzle-line',
      title: 'Juegos lógico-matemáticos',
      description: 'Primeros conceptos matemáticos de forma divertida'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Atención individualizada',
      description: 'Cuidado personalizado para cada niño'
    },
    {
      icon: 'ri-run-line',
      title: 'Psicomotricidad y Movimiento',
      description: 'Fomentamos el desarrollo físico y la coordinación a través del juego activo y el descubrimiento del cuerpo'
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'Iniciación al Inglés',
      description: 'Primer contacto con el idioma de forma natural y divertida a través de canciones, cuentos y rutinas diarias'
    }
  ];

  return (
    <section id="offer" className="py-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">¿Qué ofrecemos?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Una propuesta educativa completa para el desarrollo integral de tu hijo
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {offerings.map((offer, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 hover:shadow-lg transition-all duration-300 flex flex-col h-full"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#FF7F6E] rounded-full mb-4 flex-shrink-0">
                <i className={`${offer.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{offer.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed flex-grow">{offer.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-xl text-gray-700 font-medium max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-md">
            Todo en un entorno seguro diseñado para el juego, la exploración y el descubrimiento.
          </p>
        </div>
      </div>
    </section>
  );
}
